export const MenuItems = [
  {
    text: "Home",
    url: "/",
    cName: "navLinks",
    isActive: "active",
  },
  {
    text: "About",
    url: "/about",
    cName: "navLinks",
    isActive: "active",
  },
  {
    text: "Projects",
    url: "/projects",
    cName: "navLinks",
    isActive: "active",
  },
  {
    text: "Contact",
    url: "/contact",
    cName: "navLinks",
    isActive: "active",
  },
]
